import { IS_DEVELOPMENT } from '~/modules/config';

export const JP_SUBDOMAIN = 'appexchangejp';
export const EN_SUBDOMAIN = 'appexchange';

export const ENGLISH_LANGUAGE_CODE = 'en';
export const JAPANESE_LANGUAGE_CODE = 'ja';
export const DEBUG_LANGUAGE_CODES = ['?', 'debug'];

// The `as const` here allows us to create the LanguageCode type from constants in the code.
// It's useful to generate types, but not convenient to use, since the constant values are not compatible with string types.
// We typecast it to a string[] in the exported version so it can be used in codebase without typecasts everywhere.
const _SUPPORTED_LANGUAGES = [ENGLISH_LANGUAGE_CODE, JAPANESE_LANGUAGE_CODE] as const;
if (IS_DEVELOPMENT) {
    // @ts-expect-error add development only languages that aid in finding un-translated labels
    _SUPPORTED_LANGUAGES.push(...DEBUG_LANGUAGE_CODES);
}
export const SUPPORTED_LANGUAGES = _SUPPORTED_LANGUAGES as unknown as string[];

export type LanguageCode = (typeof _SUPPORTED_LANGUAGES)[number];
export type Marketplace = Required<schema.oaf.Force_Listing>['marketplace'];

export const ENGLISH_MARKETPLACE: Marketplace = 'English';
export const JAPANESE_MARKETPLACE: Marketplace = 'AppExchange_Japanese';

export const MARKETPLACE_TO_LANGUAGE_CODE_MAP: Record<Marketplace, LanguageCode> = {
    [ENGLISH_MARKETPLACE]: ENGLISH_LANGUAGE_CODE,
    [JAPANESE_MARKETPLACE]: JAPANESE_LANGUAGE_CODE,
};
